import { render, staticRenderFns } from "./LugarInteresModalNuevo.vue?vue&type=template&id=59b45cb8&scoped=true&"
import script from "./LugarInteresModalNuevo.vue?vue&type=script&lang=ts&"
export * from "./LugarInteresModalNuevo.vue?vue&type=script&lang=ts&"
import style0 from "./LugarInteresModalNuevo.vue?vue&type=style&index=0&id=59b45cb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b45cb8",
  null
  
)

export default component.exports